import React from 'react';
import resetPasswordImg from "img/reset-password.svg";
import LoginModelPage from "v4/pages/front/Login/components/LoginModelPage";
import useResetPasswordRequest
    from "v4/pages/front/ResetPassword/components/ResetPasswordRequest/hooks/useResetPasswordRequest";
import FormRender from "v4/components/form/FormRender/FormRender";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import LoginField from "v4/pages/front/Login/components/LoginField";
import {routesBase} from "v4/data/appRoutes";

export default function ResetPasswordRequest() {
    const {t} = usePolTranslation();
    const {
        form,
        formErrors,
        errorMessages,
        successMessages,
        onSubmit,
        isSaveLoading,
    } = useResetPasswordRequest();

    return (
        <LoginModelPage imageLeftRender={() => <img src={resetPasswordImg} alt=""/>} goBackTo={routesBase.baseLogin}>
            <p className="login__form__title">{t('mdp_oublie')}</p>
            <p className="login__form__text mb-3">{t('forgot_password_tip')}</p>

            <FormRender form={form}
                        formErrors={formErrors}
                        onSubmit={onSubmit}
                        fieldRender={(field, formRenderMethods) => (
                            <LoginField field={field} formRenderMethods={formRenderMethods}/>
                        )}
            >
                <FormRest/>

                <SubmitButton isLoading={isSaveLoading} additionalClassName="login__form__btn">
                    {t('get_link')}
                </SubmitButton>

                <div className="mt-3">
                    {successMessages && (
                        successMessages.map((message, index) => (
                            <p key={index} className="login__form__success">{t(message)}</p>
                        ))
                    )}
                    {errorMessages && (
                        errorMessages.map((message, index) => (
                            <p key={index} className="login__form__error">{t(message)}</p>
                        ))
                    )}
                </div>
            </FormRender>
        </LoginModelPage>
    )
}
